// pages/ProfitLossReportPage.jsx
import React from 'react';
import Layout from '../components/Layout';
import ProfitLossReport from '../components/ProfitLossReport';

const ProfitLossReportPage = () => {
  return (
    <Layout pageTitle="Profit & Loss Report">
      <ProfitLossReport />
    </Layout>
  );
};

export default ProfitLossReportPage;